import { useState, useEffect, useContext } from 'react';
import { useDispatch, useSelector } from "react-redux";
import { useNavigate } from 'react-router-dom';

import { getCategories } from '../../utils/api';
import { initTestsThunk, filterTestsThunk, setIsLoading } from '../../store/tests';

import MenuContext from '../../store/MenuContext';
import CategoryMenuClasses from './CategoryMenu.module.css';

const useImageExists = (imageUrl) => {
  const [exists, setExists] = useState(false);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    if (!imageUrl) {
      setExists(false);
      setLoading(false);
      return;
    }

    const img = new Image();

    img.onload = () => {
      setExists(true);
      setLoading(false);
    };

    img.onerror = () => {
      setExists(false);
      setLoading(false);
    };

    setLoading(true);
    img.src = imageUrl;

    return () => {
      img.onload = null;
      img.onerror = null;
    };
  }, [imageUrl]);

  return { exists, loading };
};	
function FileDisplay({ filePath, cat, superMenu, subCat }) {
	const imageExists = useImageExists(filePath);

	const dispatch = useDispatch();
	const navigate = useNavigate();
	const toggleCategoriesHandler = (event) => {
		sessionStorage.setItem("searchTerm", '');
		dispatch(setIsLoading());
		dispatch(filterTestsThunk(event.target.value,1,event.target.dataset.desc,event.target.dataset.name,subCat));
		if(superMenu === '1') {
			navigate(`availableTests`);
		}
	}

  return imageExists.exists  ? (
	  <>
		  <button onClick={toggleCategoriesHandler}  value={cat.Id} data-desc={cat.Description} data-name={cat.Name} >
			<img alt='FILE DNE' src={filePath} style={{ width: '48px', height: 'auto', paddingTop:'5px'}} />
			<div className={CategoryMenuClasses.categoryItem}>  {cat.Name} </div>
		 </button>
	  </>
  ) : (
    <Fallback cat= {cat} superMenu={superMenu} subCat={subCat} /> 
  );
}

function Fallback (props) {
	const dispatch = useDispatch();
	const navigate = useNavigate();
	const cat=props.cat;
	const superMenu=props.superMenu;
	const subCat=props.subCat;

	const toggleCategoriesHandler2 = async (event) => {
		sessionStorage.setItem("searchTerm", '');
		await dispatch(setIsLoading());
		await dispatch(filterTestsThunk(event.target.value,1,event.target.dataset.desc,event.target.dataset.name,subCat));
		if(superMenu === '1') {
			navigate(`availableTests`);
		}
	}

	return (
		<div key={cat.Id} className={CategoryMenuClasses.categoryItem}>
			<button onClick={toggleCategoriesHandler2} className={CategoryMenuClasses.dtctest} value={cat.Id} data-desc={cat.Description} data-name={cat.Name} >{cat.Name}</button>
		</div>
	);
}
const CategoriesSuper2 = (props) => {
	const navigate = useNavigate();

	const menuTheme = useContext(MenuContext);
	const subCategories = props.SubCat;
	const currentCat = props.CurrentCat;
	const superCat= props.SuperCat

    const testsState = useSelector(state => state.tests);
    const dispatch = useDispatch();
    const [categories, setCategories] = useState([]);

    useEffect(() => {
        async function fetchCategories() {
            const fetchedCategories = await getCategories('0');
            setCategories(fetchedCategories);
        }
        fetchCategories();
    }, []);

	 const toggleCategoriesHandler3 = (event) => {
			sessionStorage.setItem("searchTerm", '');
			dispatch(setIsLoading());
			dispatch(filterTestsThunk(event.target.value,1,event.target.dataset.desc,event.target.dataset.name,subCategories));
			if(props.Supermenu === '1') {
				navigate(`availableTests`);
			}
			window.scrollTo({ top: 0, behavior: 'smooth' });
			console.log('scroll 2?');
		}
		const categoriesList = subCategories.map((category) => {
			const elementID = `${props.idPrefix}_${category.Id}`;
			return (
				<div key={category.Id} className={CategoryMenuClasses.categoryItem2}>
					<button onClick={toggleCategoriesHandler3} className={CategoryMenuClasses.dtctest2} value={category.Id} data-desc={category.Description} data-name={category.Name} >{category.Name}</button>
				</div>
			);
		});

    return (
        <div>
			<div className={CategoryMenuClasses.categoryItemHeader}>{superCat}</div> 
			<div className={CategoryMenuClasses.categories2}>{categoriesList}</div>
        </div>
    );
};
const CategoriesSuper = (props) => {
	const navigate = useNavigate();

	const menuTheme = useContext(MenuContext);
	const superMenu=props.Supermenu;
	const subCategories = props.SubCat;
	const currentCat = props.CurrentCat;
	const superCat= props.SuperCat

    const testsState = useSelector(state => state.tests);
    const dispatch = useDispatch();
    const [categories, setCategories] = useState([]);

    useEffect(() => {
        async function fetchCategories() {
            const fetchedCategories = await getCategories('0');
            setCategories(fetchedCategories);
        }
        fetchCategories();
    }, []);

	 const toggleCategoriesHandler3 = (event) => {
			sessionStorage.setItem("searchTerm", '');
			dispatch(setIsLoading());
			dispatch(filterTestsThunk(event.target.value,1,event.target.dataset.desc,event.target.dataset.name,subCategories));
			if(props.Supermenu === '1') {
				navigate(`availableTests`);
			}
			window.scrollTo({ top: 0, behavior: 'smooth' });
			console.log('scroll?');
		}
		const categoriesList = subCategories.map((category) => {
			const elementID = `${props.idPrefix}_${category.Id}`;
			return (
			<div>
				{superMenu === '1' && 
					<div >
						<FileDisplay filePath={`/images/Icons/${category.Name}.png`} cat={category} superMenu={superMenu} subCat={subCategories} />
					</div>
				}
				{superMenu !== '1' && category.Name !== currentCat &&
					<div key={category.Id} className={CategoryMenuClasses.categoryItem}>
						<button onClick={toggleCategoriesHandler3} className={CategoryMenuClasses.dtctest2} value={category.Id} data-desc={category.Description} data-name={category.Name} >{category.Name}</button>
					</div>
				}
			</div>
			);
		});

    return (
        <div className={CategoryMenuClasses.categories}>
			{superMenu !== '1' &&
				<div>{superCat}</div> }
            {categoriesList}
        </div>
    );
};
export default CategoriesSuper;
export {CategoriesSuper2};